fragment competitionsFragment on Competition {
  score {
    active
    score
  }
  propsContent {
    props
  }
}
